import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface UserListCustomerCellProps
  extends CellContext<GatewayUserModel, GatewayUserModel['customer']> {}

export const UserListCustomerCell = (
  props: UserListCustomerCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.CUSTOMER.DETAILS, {
            id: getValue()?.id,
          }),
        )
      }
      fullWidth>
      <Text truncate>{getValue()?.name}</Text>
    </Link>
  );
};
